/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M16 15L17 16M13.5 11V13C13.5 14.1046 14.3954 15 15.5 15C16.6046 15 17.5 14.1046 17.5 13V11C17.5 9.89543 16.6046 9 15.5 9C14.3954 9 13.5 9.89543 13.5 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M16 15L17 16M13.5 11V13C13.5 14.1046 14.3954 15 15.5 15C16.6046 15 17.5 14.1046 17.5 13V11C17.5 9.89543 16.6046 9 15.5 9C14.3954 9 13.5 9.89543 13.5 11ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9V12V15C6.25 15.4142 6.58579 15.75 7 15.75C7.41421 15.75 7.75 15.4142 7.75 15V12.75H10.25V15C10.25 15.4142 10.5858 15.75 11 15.75C11.4142 15.75 11.75 15.4142 11.75 15V12V9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9V11.25H7.75V9ZM14.25 11C14.25 10.3096 14.8096 9.75 15.5 9.75C16.1904 9.75 16.75 10.3096 16.75 11V13C16.75 13.6904 16.1904 14.25 15.5 14.25C14.8096 14.25 14.25 13.6904 14.25 13V11ZM15.5 8.25C13.9812 8.25 12.75 9.48122 12.75 11V13C12.75 14.5188 13.9812 15.75 15.5 15.75C15.5616 15.75 15.6227 15.748 15.6833 15.744L16.4697 16.5303C16.7626 16.8232 17.2374 16.8232 17.5303 16.5303C17.8232 16.2374 17.8232 15.7626 17.5303 15.4697L17.2125 15.1518C17.8448 14.648 18.25 13.8713 18.25 13V11C18.25 9.48122 17.0188 8.25 15.5 8.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H15C15.9288 22 16.3933 22 16.7832 21.9487C19.4756 21.5942 21.5942 19.4756 21.9487 16.7832C22 16.3933 22 15.9288 22 15V15V14.5M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M16 15L17 16M13.5 11V13C13.5 14.1046 14.3954 15 15.5 15C16.6046 15 17.5 14.1046 17.5 13V11C17.5 9.89543 16.6046 9 15.5 9C14.3954 9 13.5 9.89543 13.5 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M16 15L17 16M13.5 11V13C13.5 14.1046 14.3954 15 15.5 15C16.6046 15 17.5 14.1046 17.5 13V11C17.5 9.89543 16.6046 9 15.5 9C14.3954 9 13.5 9.89543 13.5 11ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7 8.25C7.41421 8.25 7.75 8.58579 7.75 9V11.25H10.25V9C10.25 8.58579 10.5858 8.25 11 8.25C11.4142 8.25 11.75 8.58579 11.75 9V12V15C11.75 15.4142 11.4142 15.75 11 15.75C10.5858 15.75 10.25 15.4142 10.25 15V12.75H7.75V15C7.75 15.4142 7.41421 15.75 7 15.75C6.58579 15.75 6.25 15.4142 6.25 15V12V9C6.25 8.58579 6.58579 8.25 7 8.25ZM15.5 9.75C14.8096 9.75 14.25 10.3096 14.25 11V13C14.25 13.6904 14.8096 14.25 15.5 14.25C16.1904 14.25 16.75 13.6904 16.75 13V11C16.75 10.3096 16.1904 9.75 15.5 9.75ZM12.75 11C12.75 9.48122 13.9812 8.25 15.5 8.25C17.0188 8.25 18.25 9.48122 18.25 11V13C18.25 13.8713 17.8448 14.648 17.2125 15.1518L17.5303 15.4697C17.8232 15.7626 17.8232 16.2374 17.5303 16.5303C17.2374 16.8232 16.7626 16.8232 16.4697 16.5303L15.6833 15.744C15.6227 15.748 15.5616 15.75 15.5 15.75C13.9812 15.75 12.75 14.5188 12.75 13V11Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
